<template>
    <div style="width: 100%; display: block; padding: 5px; margin-left: auto; margin-right: auto;">
        <div style="display: block; margin-top: 10px;">
            <div v-if="items_being_loaded == true">
                <loading
                    :active="true"
                    :can-cancel="false"
                    :is-full-page="true">
                </loading>
            </div>

            <div v-else>
                <div v-if="items.length == 0">
                    <b-alert show variant="warning"> NO ITEMS IN THIS PO </b-alert>
                </div>
                <div v-else>
                    <b-card-text v-if="read_only != true" style="margin-bottom: 15px;">
                        <b-card-header class="d-flex justify-content-between align-items-center py-2">
                            <h6 class="mb-0"></h6>
                            <div class="d-flex align-items-center">
                                <label class="mb-0 mr-2 text-nowrap">Main Schedule Date:</label>
                                <date-picker
                                    v-model="mainScheduleDate"
                                    format="MM-DD-YYYY"
                                    valueType="format"
                                    placeholder="Select date for all items"
                                    style="width: 150px; margin-right: 10px;"
                                    class="mr-2"
                                ></date-picker>
                                <b-button size="sm" variant="outline-primary" @click="applyMainScheduleDate">
                                    Apply to All
                                </b-button>
                            </div>
                        </b-card-header>
                    </b-card-text>
                    <div class="diver">
                        <table>
                            <thead>
                                <tr>
                                    <th class="srr" style="width: 120px;">SKU</th>
                                    <th class="srr" style="width: 150px;">PRODUCT NAME</th>
                                    <th class="srr" style="width: 50px;">QTY ORD</th>
                                    <th class="srr" style="width: 50px;">QTY SCH</th>
                                     <th class="srr" style="width: 50px;">QTY RVD</th>
                                    <th class="srr" style="width: 100px;">STATUS</th>
                                  
                                    <th class="srr" style="width: 120px;">SCHEDULE DATE</th>
                           
                                    <th class="srr" style="width: 120px;">RECEIVED DATE</th>
                                    <!-- <th class="srr" style="width: 100px;">AVAILABLE STOCK</th>
                                    <th class="srr" style="width: 100px;">RESERVED STOCK</th> -->
                                    <th class="srr" style="width: 120px;">RECEIVING LOCATION</th>
                                    <th class="srr" style="width: 150px;">ACTION</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item,idx in items" v-bind:key="idx">
                                    <td class="srrv">{{item.product_sku}}</td>
                                    <td class="srrv">{{item.product_name}}</td>
                                    <td class="srrv">{{item.quantity_ordered}}</td>
                                        <td class="srrv">
                                        <b-form-input
                                            v-model="item.quantity_scheduled"
                                            type="number"
                                            size="sm"
                                            min="0"
                                            :max="item.quantity_ordered"
                                            @change="handleScheduleChange(item)"
                                        ></b-form-input>
                                    </td>
                                        <td class="srrv">
                                        <b-form-input
                                            v-model="item.quantity_received"
                                            type="number"
                                            size="sm"
                                            min="0"
                                            :max="item.quantity_ordered"
                                            @change="handleReceivedChange(item)"
                                        ></b-form-input>
                                    </td>
                                    <td class="srrv" :style="{
                                        backgroundColor: statusColors[item.status],
                                        color: getStatusTextColor(item.status),
                                        textAlign: 'center',
                                    }">
                                        <b-form-select
                                            :options="statusOptions"
                                            v-model="item.status"
                                            size="sm"
                                            style="font-size: 11px; background: transparent; border: 1px solid rgba(0,0,0,0.3)"
                                            @change="handleStatusChange(item)"
                                        ></b-form-select>
                                    </td>
                                
                                    <td class="srrv" style="position: relative;">
                                        <date-picker
                                            v-model="item.schedule_date"
                                            format="MM-DD-YYYY"
                                            valueType="format"
                                            @change="handleScheduledDateChange(item)"
                                            style="padding: 1px; font-size: 9px; text-align: center; border: 1px solid gray; width: 110px; font-size: 11px;"
                                        ></date-picker>
                                    </td>
                                
                                    <td class="srrv">
                                        <date-picker
                                            v-model="item.receiving_date"
                                            format="MM-DD-YYYY"
                                            valueType="format"
                                            :disabled="!['PARTIAL', 'RECEIVED'].includes(item.status)"
                                            style="padding: 1px; font-size: 9px; text-align: center; border: 1px solid gray; width: 110px; font-size: 11px;"
                                        ></date-picker>
                                    </td>
                                    <!-- <td class="srrv">{{item.available_stock}}</td>
                                    <td class="srrv">{{item.reserved_stock}}</td> -->
                                    <td class="srrv">{{packet.locsubsdict[item.locsub]}}</td>
                                   
                                    <td class="srrv">
                                        <div style="display: inline-block;">
                                            <b-button size="sm" variant="outline-success"
                                                @click="saveItem(item)" v-b-tooltip.hover title="SAVE ITEM">
                                                <b-icon icon="check-square" aria-hidden="true"></b-icon>
                                            </b-button>
                                        </div>
                                        <div style="display: inline-block;">
                                            <b-button
                                                size="sm"
                                                variant="outline-danger"
                                                @click="deleteItem(item)"
                                                v-b-tooltip.hover
                                                title="DELETE ITEM"
                                            >
                                                <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
                                            </b-button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';

    export default {
        name: "LowInventoryPOItems",
        props: ["viewdata"],
        components: { Loading, DatePicker },
        data: function(){
            return {
                packet: {},
                items: [],
                items_being_loaded: null,
                mainScheduleDate: null,
                statusOptions: [
                    { value: "NEW", text: "NEW" },
                    { value: "ORDERED", text: "ORDERED" },
                    { value: "SCHEDULED", text: "SCHEDULED" },
                    { value: "IN-TRANSIT", text: "IN-TRANSIT" },
                    { value: "PARTIAL", text: "PARTIAL" },
                    { value: "RECEIVED", text: "RECEIVED" },
                    { value: "COMPLETED", text: "COMPLETED" },
                    { value: "ARCHIVED", text: "ARCHIVED" }
                ],
                statusColors: {
                    "NEW": '#f8f9fa',
                    "ORDERED": '#e3f2fd',
                    "SCHEDULED": '#fff3e0',
                    "IN-TRANSIT": '#fff3e0',
                    "PARTIAL": '#fff9c4',
                    "RECEIVED": '#c8e6c9',
                    "COMPLETED": '#c8e6c9',
                    "ARCHIVED": '#f5f5f5'
                }
            };
        },
        computed: {
            isAdmin() {
                return this.packet.userDetails.userrole === 'admin';
            }
        },
        mounted() {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.fetch_items();
        },
        methods: {
            getStatusTextColor(status) {
                return status === "COMPLETED" ? 'white' : 'black';
            },
            applyMainScheduleDate() {
                if (!this.mainScheduleDate) {
                    this.$bvToast.toast(
                        "Please select a main schedule date first",
                        {title: "Validation Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    return;
                }

                this.items.forEach(item => {
                    // Only update items that don't have received status
                    if (!['RECEIVED', 'COMPLETED', 'ARCHIVED'].includes(item.status)) {
                        item.schedule_date = this.mainScheduleDate;
                        // If setting a schedule date, also set status to scheduled if not already
                        if (item.status !== "SCHEDULED") {
                            item.status = "SCHEDULED";
                        }
                        // Set scheduled quantity to ordered quantity if not already set
                        if (!item.quantity_scheduled || item.quantity_scheduled === 0) {
                            item.quantity_scheduled = item.quantity_ordered;
                        }
                    }
                });

                this.$bvToast.toast(
                    `Main schedule date applied to all items`,
                    { title: "Success", autoHideDelay: 3000, variant: "success" }
                );
            },
            fetch_items: function() {
                let that = this;
                let path = "/api/sales/get_low_inventory_po_items/";
                let data = {
                    low_inventory_po_id: this.viewdata.low_inventory_po_id
                };

                let s = function(response) {
                    if (response.data.result) {
                        that.items = response.data.result;
                        // Initialize quantities and dates if not present
                        that.items.forEach(item => {
                            // Ensure quantities are numbers
                            item.quantity_ordered = Number(item.quantity_ordered) || 0;
                            item.quantity_scheduled = Number(item.quantity_scheduled) || 0;
                            item.quantity_received = Number(item.quantity_received) || 0;
                            item.status = item.status || "NEW";
                            // Format dates if they exist
                            if (item.schedule_date) {
                                // Convert from YYYY-MM-DD to MM-DD-YYYY if needed
                                item.schedule_date = that.formatDate(item.schedule_date);
                            }
                            if (item.receiving_date) {
                                item.receiving_date = that.formatDate(item.receiving_date);
                            }
                        });
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                }

                let f = function(error) {
                    console.log(error);
                    that.$bvToast.toast(
                        "Error occurred. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                }

                this.items_being_loaded = true;
                Requestor.postSyncP(path, data, this, s, f);
            },
            formatDate(dateString) {
                if (!dateString) return null;
                // Convert from YYYY-MM-DD to MM-DD-YYYY
                const parts = dateString.split('-');
                if (parts.length === 3) {
                    // If it's already in YYYY-MM-DD format
                    if (parts[0].length === 4) {
                        return `${parts[1]}-${parts[2]}-${parts[0]}`;
                    }
                }
                return dateString;
            },
            handleScheduleChange(item) {
                // Convert to number
                item.quantity_scheduled = Number(item.quantity_scheduled) || 0;
                
                // Validate scheduled quantity
                if (item.quantity_scheduled > item.quantity_ordered) {
                    this.$bvToast.toast(
                        `Scheduled quantity cannot exceed ordered quantity (${item.quantity_ordered})`,
                        {title: "Validation Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    item.quantity_scheduled = 0;
                    return;
                }
                
                if (item.quantity_scheduled > 0) {
                    item.status = "SCHEDULED";
                    // Set schedule date if not already set
                    if (!item.schedule_date) {
                        const today = new Date();
                        item.schedule_date = `${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}-${today.getFullYear()}`;
                    }
                } else if (item.quantity_scheduled === 0) {
                    // If scheduled quantity is set to 0, revert status if appropriate
                    // Only revert if no received quantity and not in a received state
                    if ((item.quantity_received || 0) === 0 && !['PARTIAL', 'RECEIVED', 'COMPLETED'].includes(item.status)) {
                        // Revert to ORDERED status
                        item.status = "ORDERED";
                    }
                }
            },
            handleScheduledDateChange(item) {
                if (item.schedule_date) {
                    // Only auto-change status if it's in a pre-scheduled state
                    const preScheduledStatuses = ["NEW", "ORDERED"];
                    if (preScheduledStatuses.includes(item.status)) {
                        item.status = "SCHEDULED";
                    }

                    // If there's a scheduled date but no scheduled quantity, set it to ordered quantity
                    if ((!item.quantity_scheduled || item.quantity_scheduled === 0) && item.quantity_ordered > 0) {
                        item.quantity_scheduled = item.quantity_ordered;
                    }
                }
            },
            handleReceivedChange(item) {
                // Convert to number
                item.quantity_received = Number(item.quantity_received) || 0;
                
                // Validate received quantity
                if (item.quantity_received > item.quantity_ordered) {
                    this.$bvToast.toast(
                        `Received quantity cannot exceed ordered quantity (${item.quantity_ordered})`,
                        {title: "Validation Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    item.quantity_received = 0;
                    return;
                }
                
                // Validate against scheduled quantity if it exists
                if (item.quantity_scheduled > 0 && item.quantity_received > item.quantity_scheduled) {
                    this.$bvToast.toast(
                        `Received quantity cannot exceed scheduled quantity (${item.quantity_scheduled})`,
                        {title: "Validation Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    item.quantity_received = item.quantity_scheduled;
                    return;
                }
                
                console.log("Received change:", {
                    received: item.quantity_received,
                    ordered: item.quantity_ordered,
                    scheduled: item.quantity_scheduled,
                    typeReceived: typeof item.quantity_received,
                    typeOrdered: typeof item.quantity_ordered
                });
                
                if (item.quantity_received > 0) {
                    // Set receiving date if not already set
                    if (!item.receiving_date) {
                        const today = new Date();
                        item.receiving_date = `${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}-${today.getFullYear()}`;
                    }
                    
                    // Update status based on received quantity - use strict comparison
                    if (item.quantity_received === item.quantity_ordered) {
                        console.log("Setting status to RECEIVED - quantities match");
                        item.status = "RECEIVED";
                        // Also ensure scheduled quantity equals ordered quantity when fully received
                        if (item.quantity_scheduled !== item.quantity_ordered) {
                            item.quantity_scheduled = item.quantity_ordered;
                        }
                    } else if (item.quantity_received < item.quantity_ordered) {
                        console.log("Setting status to PARTIAL - received less than ordered");
                        item.status = "PARTIAL";
                    }
                } else if (item.quantity_received === 0) {
                    console.log("Received quantity is 0");
                    // If received quantity is set to 0, clear receiving date and revert status
                    item.receiving_date = null;
                    if (['PARTIAL', 'RECEIVED'].includes(item.status)) {
                        // Revert to previous valid status
                        if (item.quantity_scheduled > 0) {
                            item.status = "SCHEDULED";
                        } else {
                            item.status = "ORDERED";
                        }
                    }
                }
                
                // Debug log
                console.log("Final status:", item.status);
            },
            handleStatusChange(item) {
                console.log("Status changed to:", item.status);
                
                if (item.status === "RECEIVED") {
                    // When status is set to RECEIVED, set received quantity to ordered quantity
                    item.quantity_received = item.quantity_ordered;
                    // Also set scheduled quantity to ordered quantity
                    item.quantity_scheduled = item.quantity_ordered;
                    // Set receiving date if not already set
                    if (!item.receiving_date) {
                        const today = new Date();
                        item.receiving_date = `${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}-${today.getFullYear()}`;
                    }
                } else if (item.status === "PARTIAL") {
                    // When status is set to PARTIAL, ensure we have some received quantity
                    if (!item.quantity_received || item.quantity_received === 0) {
                        item.quantity_received = 1;
                    }
                    // Set receiving date if not already set
                    if (!item.receiving_date) {
                        const today = new Date();
                        item.receiving_date = `${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}-${today.getFullYear()}`;
                    }
                } else if (item.status === "SCHEDULED") {
                    // When status is set to SCHEDULED, set scheduled quantity if not set
                    if (!item.quantity_scheduled || item.quantity_scheduled === 0) {
                        item.quantity_scheduled = item.quantity_ordered;
                    }
                    // Set schedule date if not already set
                    if (!item.schedule_date) {
                        const today = new Date();
                        item.schedule_date = `${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}-${today.getFullYear()}`;
                    }
                } else if (['NEW', 'ORDERED', 'IN-TRANSIT'].includes(item.status)) {
                    // Clear receiving date for non-receiving statuses
                    item.receiving_date = null;
                }
                
                // Clear receiving date if status is not PARTIAL or RECEIVED
                if (!['PARTIAL', 'RECEIVED'].includes(item.status)) {
                    item.receiving_date = null;
                }
            },
            saveItem: function(item) {
                let that = this;
                let path = "/api/sales/save_low_inventory_po_items/";
                
                // Prepare the item data for saving
                const itemToSave = {
                    ...item,
                    // Convert dates back to YYYY-MM-DD format for backend if needed
                    schedule_date: item.schedule_date ? this.convertToYYYYMMDD(item.schedule_date) : null,
                    receiving_date: item.receiving_date ? this.convertToYYYYMMDD(item.receiving_date) : null
                };
                
                let data = {
                    low_inventory_po_id: this.viewdata.low_inventory_po_id,
                    items: [itemToSave],
                    created_by: this.packet.userDetails.username
                };

                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "ITEM SAVED",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        that.fetch_items();
                    }
                }

                let f = function(error) {
                    console.log(error);
                    that.$bvToast.toast(
                        "Error occurred in saving. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                
                Requestor.postSyncP(path, data, this, s, f);
            },
            convertToYYYYMMDD(dateString) {
                if (!dateString) return null;
                // Convert from MM-DD-YYYY to YYYY-MM-DD
                const parts = dateString.split('-');
                if (parts.length === 3) {
                    // If it's in MM-DD-YYYY format
                    if (parts[2].length === 4) {
                        return `${parts[2]}-${parts[0].padStart(2, '0')}-${parts[1].padStart(2, '0')}`;
                    }
                }
                return dateString;
            },
            deleteItem: function(item) {
                if (!confirm("Are you sure you want to delete this item?")) {
                    return;
                }

                let that = this;
                let path = "/api/sales/delete_low_inventory_po_item/";
                let data = {
                    id: item.id
                };

                let s = function(response) {
                    if (response.data.error) {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"danger"}
                        );
                    }
                    else {
                        that.$bvToast.toast(
                            "ITEM DELETED",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        that.fetch_items();
                    }
                }

                let f = function(error) {
                    console.log(error);
                    that.$bvToast.toast(
                        "Error occurred in deleting. Please try again.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                }
                
                Requestor.postSyncP(path, data, this, s, f);
            }
        }
    }
</script>
<style scoped>
    .diver {
      overflow:auto;
      width:100%;
      height:600px;
    }
    td,
    th {
      border: 1px solid;
      width: 300px;
    }
    th {background-color:white;}

    table {
      table-layout: fixed;
      width:100%;
    }
    td:first-child, th:first-child {
      position:sticky;
      left:0;
      z-index:1;
      background-color: white;
    }

    td:last-child, th:last-child {
      position:sticky;
      right:0;
      z-index:1;
      background-color:white;
      width: 150px;
    }
    thead tr th {
      position:sticky;
      top:0;
    }
    th:first-child, th:last-child {
        z-index:2;background-color:white;
    }

    .srr {
        font-size: 12px;
        text-align: center;
        background: #efefef;
        border: 1px solid #010101;
    }

    .srrv {
        font-size: 13px;
        text-align: center;
        background: white;
        border: 1px solid #010101;
        padding: 5px;
    }
    
    .srrv input {
        /* width: 80px; */
        text-align: center;
    }
    
    ::v-deep .srrv .custom-select {
        background: transparent !important;
        border: 1px solid rgba(0,0,0,0.2) !important;
        color: inherit !important;
    }
    
    ::v-deep .srrv .mx-input {
        border: 1px solid rgba(0,0,0,0.2) !important;
        font-size: 11px !important;
        height: 30px !important;
        padding: 2px 5px !important;
    }
    
    ::v-deep .srrv .mx-input:disabled {
        background: rgba(240, 240, 240, 0.7) !important;
        opacity: 0.7;
    }
</style>


// WEBPACK FOOTER //
// src/components/VendorOrders/LowInventoryPOItems.vue